import { BrickDefinition } from '../../samwebDescription/samweb/brickDefinition';

export function SamwebBrick(brickDefinition: BrickDefinition) {
   return function decorator(target) {
      target.samWebBrickId = brickDefinition.brickDefinitionId;
      target.samWebBrickDefinition = brickDefinition;
   };
}
